export default __webpack_public_path__ + "assets/c201cd88dd8ac881fb5116d6e523f6c0.svg";